import {
  Box,
  Button,
  Card,
  Chip,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useSubscriptions } from "@/services/hooks";
import { fetchStripeBillingPortal } from "@/services/api";
import { useState } from "react";
import { formatDate } from "@/utils/time";

export default function Billing() {
  const { data: subscriptions } = useSubscriptions();

  const filteredSubscriptions = subscriptions?.filter(
    (subscription) => subscription.stripe_id?.startsWith("sub_")
  );
  return (
    <Box sx={{ pt: 2 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
        {filteredSubscriptions?.map((subscription) => (
          <SubscriptionCard key={subscription.id} subscription={subscription} />
        ))}
      </Box>
    </Box>
  );
}

function SubscriptionCard({ subscription }) {
  const [loading, setLoading] = useState(false);
  const handleManage = async () => {
    setLoading(true);
    const response = await fetchStripeBillingPortal(subscription.stripe_id);
    window.location.href = response.url;
    setTimeout(() => setLoading(false), 1000);
  };

  const getIsoDate = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleDateString("en-US", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <Card sx={{ p: 2, borderRadius: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          gap={2}
        >
          <Typography
            style={{
              fontFamily: "'Montserrat Alternates', sans-serif",
              fontWeight: 700,
              fontSize: "1.1rem",
            }}
          >
            {subscription.artist.key}
          </Typography>

          {subscription.canceled && (
            <Chip
              label="Canceled"
              color="info"
              variant="outlined"
              size="small"
            />
          )}
        </Stack>
        <Button
          variant="text"
          color="primary"
          size="small"
          onClick={handleManage}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : "Manage"}
        </Button>
      </Stack>
    </Card>
  );
}
